if (!customElements.get("media-gallery")) {
  customElements.define(
    "media-gallery",
    class MediaGallery extends HTMLElement {
      constructor() {
        super();

        this.selectors = {
          viewer: '[id^="GalleryViewer"]',
          thumbnails: '[id^="GalleryThumbnails"]',
          mediaList: '[id^="Slider-Gallery"]',
          mediaItems: [".product__media-item"],
        };

        this.sliderInstance = false;
        this.thumbsInstance = false;
      }

      connectedCallback() {
        this.init();
      }

      init() {
        this.elements = window.FoxTheme.utils.queryDomNodes(this.selectors, this);
        this.mediaLayout = this.dataset.mediaLayout;
        this.onlyImage = this.dataset.onlyImage === "true";
        this.enableDesktopSlider = this.dataset.enableDesktopSlider === "true";
        this.enableMobileThumbnails = this.dataset.enableMobileThumbnails === "true";
        this.enableImageZoom = this.dataset.enableImageZoom === "true";
        this.setSliderOptions();

        const mql = window.matchMedia(FoxTheme.config.mediaQueryMobile);
        mql.onchange = this.updateMediaLayout.bind(this);
        this.updateMediaLayout();

        if (this.enableImageZoom) {
          this.initImageZoom();
        }
      }

      setSliderOptions() {
        const mediaItemGap = parseInt(this.dataset.mediaItemGap);

        this.sliderOptions = {
          init: false,
          slidesPerView: "1",
          spaceBetween: mediaItemGap,
          loop: true,
          grabCursor: true,
          allowTouchMove: true,
          autoHeight: true,
          navigation: {
            nextEl: this.querySelector(".swiper-button-next"),
            prevEl: this.querySelector(".swiper-button-prev"),
          },
          pagination: {
            el: this.querySelector(".swiper-pagination"),
            clickable: true,
            type: "bullets",
          },
          threshold: 2,
          effect: "slide",
  fadeEffect: {
    crossFade: true,
  },
  speed: 350,
        };

        this.thumbsOptions = {
          slidesPerView: 4,
          breakpoints: {
            461: {
              slidesPerView: 5,
            },
          },
          spaceBetween: mediaItemGap,
          loop: false,
          freeMode: true,
          watchSlidesProgress: true,
          threshold: 2,
        };

        switch (this.mediaLayout) {
          case "vertical-carousel":
            this.thumbsOptions = Object.assign({}, this.thumbsOptions, {
              direction: "vertical",
              slidesPerView: "auto",
              spaceBetween: 16,
              mousewheel: {
                enabled: true,
                releaseOnEdges: false,
                sensitivity: 0.5,
              },
              navigation: {
                nextEl: ".swiper-button-next-thumbs",
                prevEl: ".swiper-button-prev-thumbs",
              },
              breakpoints: {
                768: {
                  direction: "vertical",
                  slidesPerView: "auto",
                },
              },
            });
            break;
          case "slider-freemode":
            this.sliderOptions = Object.assign({}, this.sliderOptions, {
              slidesPerView: "auto",
            });
            break;
        }
      }

      updateMediaLayout() {
        if (FoxTheme.config.mqlMobile) {
          this.initSlider();
        } else {
          if (this.enableDesktopSlider) {
            this.initSlider();
          } else {
            this.destroySlider();
          }
        }
      }

      initSlider() {
        if (typeof this.sliderInstance !== "object") {
          if ((this.enableDesktopSlider || this.enableMobileThumbnails) && this.elements.thumbnails) {
            this.thumbsInstance = new window.FoxTheme.Carousel(this.elements.thumbnails, this.thumbsOptions, [FoxTheme.Swiper.Mousewheel]);
            this.thumbsInstance.init();

            this.sliderOptions.thumbs = {
              swiper: this.thumbsInstance.slider,
              autoScrollOffset: 2,
            };
          }

          this.sliderInstance = new window.FoxTheme.Carousel(this.elements.viewer, this.sliderOptions, [FoxTheme.Swiper.Thumbs,  FoxTheme.Swiper.EffectFade]);
          this.sliderInstance.init();

          this.handleSliderAfterInit();
          this.handleSlideChange();

          this.sliderInstance.slider.init();
        }
      }

      destroySlider() {
        if (typeof this.sliderInstance === "object") {
          this.sliderInstance.slider.destroy();
          this.sliderInstance = false;
        }
      }

      initThumbsSlider() {
        if (typeof this.thumbsInstance !== "object") {
          this.thumbsInstance = new window.FoxTheme.Carousel(this.selectors.thumbnails, this.thumbsOptions);
          this.thumbsInstance.init();
        }
      }

      initImageZoom() {
        let dataSource = [];
        const allMedia = [...this.querySelectorAll(".product__media-item:not(.swiper-slide-duplicate)")];
        if (allMedia) {
          allMedia.forEach((media) => {
            switch (media.dataset.mediaType) {
              case "model":
                dataSource.push({
                  id: media.dataset.mediaIndex,
                  html: `<div class="pswp__item--${media.dataset.mediaType}">${media.querySelector("product-model").outerHTML}</div>`,
                  mediaType: media.dataset.mediaType,
                });
                break;
              case "video":
              case "external_video":
                dataSource.push({
                  id: media.dataset.mediaIndex,
                  html: `<div class="pswp__item--${media.dataset.mediaType}">${media.querySelector("video-element").outerHTML}</div>`,
                  mediaType: media.dataset.mediaType,
                });
                break;
              case "image":
                dataSource.push({
                  id: media.dataset.mediaIndex,
                  src: media.dataset.src,
                  width: media.dataset.pswpWidth,
                  height: media.dataset.pswpHeight,
                  mediaType: media.dataset.mediaType,
                });
                break;
            }
          });
        }

        this.lightbox = new window.FoxTheme.PhotoSwipeLightbox({
          dataSource: dataSource,
          pswpModule: window.FoxTheme.PhotoSwipe,
          bgOpacity: 1,
          showHideAnimationType: 'zoom',
          initialZoomLevel: 'fit',
          secondaryZoomLevel: 2,
          maxZoomLevel: 4,
        });

        this.lightbox.addFilter("thumbEl", (thumbEl, { id }, index) => {
          if (this.sliderInstance && this.sliderInstance.slider) {
            const { slides, activeIndex } = this.sliderInstance.slider;
            if (slides[activeIndex]) {
              const el = slides[activeIndex].querySelector("img");
              if (el) {
                return el;
              }
            }
          }

          return thumbEl;
        });

        this.lightbox.addFilter("placeholderSrc", (placeholderSrc, { data: { id } }) => {
          if (this.sliderInstance && this.sliderInstance.slider) {
            const { slides, activeIndex } = this.sliderInstance.slider;
            if (slides[activeIndex]) {
              const el = slides[activeIndex].querySelector("img");
              if (el) {
                return el.src;
              }
            }
          }

          return placeholderSrc;
        });

        this.lightbox.on('change', () => {
          window.pauseAllMedia(this);
        });

        this.lightbox.on('destroy', () => {
          const { currIndex } = this.lightbox.pswp;

          if (this.sliderInstance && this.sliderInstance.slider) {
            this.sliderInstance.slider.slideToLoop(currIndex, 0, false);
          }
        });

        this.lightbox.on('pointerDown', (e) => {
          if (this.lightbox.pswp.currSlide.data.mediaType != 'image') {
            e.preventDefault();
          }
        });

        this.lightbox.on('uiRegister', () => {
          // Register vertical thumbnail navigation
          this.lightbox.pswp.ui.registerElement({
            name: 'thumbnail-prev',
            ariaLabel: 'Previous thumbnail',
            order: 1,
            isButton: true,
            html: '<svg xmlns="http://www.w3.org/2000/svg" width="15" height="11" viewBox="0 0 15 11" fill="none"><path d="M0.105469 10.051C0.80129 9.89968 3.29469 9.23402 5.20464 6.05504C6.62154 3.69671 6.99119 1.16389 7.10547 0.0510253" stroke="black" stroke-miterlimit="10"/><path d="M14.1055 10.051C13.4096 9.89968 10.9162 9.23402 9.0063 6.05504C7.5894 3.69671 7.21975 1.16388 7.10547 0.0510239" stroke="black" stroke-miterlimit="10"/></svg>',
            onInit: (el, pswp) => {
              el.style.cssText = 'position: absolute; top: 20px; left: 20px; width: 40px; height: 40px; display: flex; align-items: center; justify-content: center; background: white; border-radius: 50%; cursor: pointer; z-index: 1000;';
            },
            onClick: (event, el) => {
              const thumbContainer = document.querySelector('.pswp__thumbnails');
              if (thumbContainer) {
                thumbContainer.scrollTop -= 120;
              }
            },
          });

          // Register thumbnail container
          this.lightbox.pswp.ui.registerElement({
            name: 'thumbnails-container',
            order: 2,
            isButton: false,
            appendTo: 'wrapper',
            onInit: (el, pswp) => {
              el.style.cssText = 'position: absolute; left: 20px; top: 80px; bottom: 80px; width: 100px; overflow-y: auto; overflow-x: hidden; z-index: 999; display: flex; flex-direction: column; gap: 16px; scrollbar-width: none;';
              el.className = 'pswp__thumbnails';
              el.innerHTML = '';

              // Add custom scrollbar hiding
              const style = document.createElement('style');
              style.textContent = '.pswp__thumbnails::-webkit-scrollbar { display: none; }';
              document.head.appendChild(style);

              dataSource.forEach((item, index) => {
                if (item.mediaType === 'image') {
                  const thumb = document.createElement('div');
                  thumb.className = 'pswp__thumbnail';
                  thumb.style.cssText = 'width: 100px; height: 100px; cursor: pointer; border: 2px solid transparent; border-radius: 4px; overflow: hidden; flex-shrink: 0;';
                  
                  const img = document.createElement('img');
                  img.src = item.src;
                  img.style.cssText = 'width: 100%; height: 100%; object-fit: cover;';
                  thumb.appendChild(img);

                  thumb.addEventListener('click', () => {
                    pswp.goTo(index);
                  });

                  el.appendChild(thumb);
                }
              });

              // Update active thumbnail on slide change
              pswp.on('change', () => {
                el.querySelectorAll('.pswp__thumbnail').forEach((thumb, i) => {
                  if (i === pswp.currIndex) {
                    thumb.style.borderColor = '#000';
                    thumb.classList.add("active");
                  } else {
                    thumb.style.borderColor = 'transparent';
                    thumb.classList.remove("active");
                  }
                });

                // Auto-scroll to active thumbnail
                const activeThumbs = el.querySelectorAll('.pswp__thumbnail');
                if (activeThumbs[pswp.currIndex]) {
                  activeThumbs[pswp.currIndex].scrollIntoView({ behavior: 'smooth', block: 'nearest' });
                }
              });

              // Set initial active state
              setTimeout(() => {
                const firstThumb = el.querySelector('.pswp__thumbnail');
                if (firstThumb) {
                  firstThumb.style.borderColor = '#000';
                  firstThumb.classList.add("active");
                }
              }, 100);
            },
          });

          // Register vertical thumbnail navigation - down arrow
          this.lightbox.pswp.ui.registerElement({
            name: 'thumbnail-next',
            ariaLabel: 'Next thumbnail',
            order: 3,
            isButton: true,
            html: '<svg xmlns="http://www.w3.org/2000/svg" width="15" height="11" viewBox="0 0 15 11" fill="none"><path d="M14.1055 0.488525C13.4096 0.639874 10.9162 1.30553 9.0063 4.48451C7.5894 6.84284 7.21974 9.37566 7.10547 10.4885" stroke="black" stroke-miterlimit="10"/><path d="M0.105469 0.488525C0.80129 0.639875 3.29469 1.30553 5.20464 4.48451C6.62153 6.84284 6.99119 9.37567 7.10547 10.4885" stroke="black" stroke-miterlimit="10"/></svg>',
            onInit: (el, pswp) => {
              el.style.cssText = 'position: absolute; bottom: 20px; left: 20px; width: 40px; height: 40px; display: flex; align-items: center; justify-content: center; background: white; border-radius: 50%; cursor: pointer; z-index: 1000;';
            },
            onClick: (event, el) => {
              const thumbContainer = document.querySelector('.pswp__thumbnails');
              if (thumbContainer) {
                thumbContainer.scrollTop += 120;
              }
            },
          });

          // Register zoom in button
          this.lightbox.pswp.ui.registerElement({
            name: 'zoom-in-button',
            ariaLabel: 'Zoom in',
            order: 10,
            isButton: true,
            html: '<svg xmlns="http://www.w3.org/2000/svg" width="23" height="23" viewBox="0 0 23 23" fill="none"><path fill-rule="evenodd" clip-rule="evenodd" d="M11.316 0.00668959V22.6152V0.00668959Z" fill="white"/><path d="M11.316 0.00668972V22.6152" stroke="black" stroke-linecap="round" stroke-linejoin="round"/><path fill-rule="evenodd" clip-rule="evenodd" d="M11.3043 22.6369V45.2454V22.6369Z" fill="white"/><path d="M11.3043 22.6369V45.2454" stroke="black" stroke-linecap="round" stroke-linejoin="round"/><path fill-rule="evenodd" clip-rule="evenodd" d="M22.6298 11.3161L0 11.3137L22.6298 11.3161Z" fill="white"/><path d="M22.6298 11.3161L0 11.3137" stroke="black" stroke-linecap="round" stroke-linejoin="round"/><path fill-rule="evenodd" clip-rule="evenodd" d="M43.8427 11.3161L21.2129 11.3137L43.8427 11.3161Z" fill="white"/><path d="M43.8427 11.3161L21.2129 11.3137" stroke="black" stroke-linecap="round" stroke-linejoin="round"/></svg>',
            onInit: (el, pswp) => {
              el.style.cssText = 'position: absolute; top: 20px; right: 20px; width: 48px; height: 48px; display: flex; align-items: center; justify-content: center; background: white; border-radius: 50%; cursor: pointer;';
            },
            onClick: (event, el) => {
              this.lightbox.pswp.zoomTo(
                this.lightbox.pswp.currSlide.currZoomLevel * 1.5,
                { x: this.lightbox.pswp.currSlide.bounds.center.x, y: this.lightbox.pswp.currSlide.bounds.center.y },
                300
              );
            },
          });

          // Register zoom level display
          this.lightbox.pswp.ui.registerElement({
            name: 'zoom-level-display',
            order: 11,
            isButton: false,
            onInit: (el, pswp) => {
              el.style.cssText = 'position: absolute; top: 88px; right: 20px; width: 48px; height: 32px; display: flex; align-items: center; justify-content: center; color: #000; font-size: 14px; font-weight: 500;';
              el.textContent = '100%';
              
              const updateZoomLevel = () => {
                if (pswp.currSlide && pswp.currSlide.currZoomLevel && pswp.currSlide.zoomLevels) {
                  const zoomLevel = Math.round((pswp.currSlide.currZoomLevel / pswp.currSlide.zoomLevels.initial) * 100);
                  el.textContent = `${zoomLevel}%`;
                }
              };
              
              pswp.on('zoomPanUpdate', updateZoomLevel);
              pswp.on('change', updateZoomLevel);
              
              setTimeout(updateZoomLevel, 100);
            }
          });

          // Register zoom out button
          this.lightbox.pswp.ui.registerElement({
            name: 'zoom-out-button',
            ariaLabel: 'Zoom out',
            order: 12,
            isButton: true,
            html: '<svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 48 48" fill="none"><line x1="15" y1="24.5" x2="33" y2="24.5" stroke="black"/></svg>',
            onInit: (el, pswp) => {
              el.style.cssText = 'position: absolute; top: 136px; right: 20px; width: 48px; height: 48px; display: flex; align-items: center; justify-content: center; background: white; border-radius: 50%; cursor: pointer;';
            },
            onClick: (event, el) => {
              this.lightbox.pswp.zoomTo(
                this.lightbox.pswp.currSlide.currZoomLevel * 0.75,
                { x: this.lightbox.pswp.currSlide.bounds.center.x, y: this.lightbox.pswp.currSlide.bounds.center.y },
                300
              );
            },
          });

          // Register navigation buttons at bottom
          if (!this.onlyImage) {
            this.lightbox.pswp.ui.registerElement({
              name: 'custom-prev',
              ariaLabel: 'Previous slide',
              order: 7,
              isButton: true,
              html: '<svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none"><circle cx="20" cy="20" r="20" fill="white"/><path d="M30 21.25L13.3333 21.25" stroke="black" stroke-miterlimit="10"/><path d="M21.666 27.0834C21.5399 26.5035 20.9852 24.4257 18.336 22.8341C16.3708 21.6533 14.2601 21.3453 13.3327 21.25" stroke="black" stroke-miterlimit="10"/><path d="M21.666 15.4167C21.5399 15.9966 20.9852 18.0744 18.336 19.6661C16.3708 20.8468 14.2601 21.1548 13.3327 21.2501" stroke="black" stroke-miterlimit="10"/></svg>',
              onInit: (el, pswp) => {
                el.style.cssText = 'position: absolute; bottom: 32px; left: 50%; transform: translateX(-111px); width: 48px; height: 48px; display: flex; align-items: center; justify-content: center; background: white; border-radius: 50%; cursor: pointer;';
              },
              onClick: (event, el) => {
                this.lightbox.pswp.prev();
              },
            });
            
            this.lightbox.pswp.ui.registerElement({
              name: 'custom-close',
              ariaLabel: 'Close',
              order: 8,
              isButton: true,
              html: '<svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_4958_14909)"><path fill-rule="evenodd" clip-rule="evenodd" d="M15.9964 0.00585938L0.00976562 15.9925L15.9964 0.00585938Z" fill="currentColor"></path><path d="M15.9964 0.00585938L0.00976562 15.9925" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M-0.0133448 16L-16 31.9867L-0.0133448 16Z" fill="currentColor"></path><path d="M-0.0133449 16L-16 31.9867" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M16 16.0033L0 0L16 16.0033Z" fill="currentColor"></path><path d="M16 16.0033L0 0" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M31 31.0033L15 15L31 31.0033Z" fill="currentColor"></path><path d="M31 31.0033L15 15" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"></path></g><defs><clipPath id="clip0_4958_14909"><rect width="16" height="16.0033" fill="currentColor"></rect></clipPath></defs></svg>',
              onInit: (el, pswp) => {
                el.style.cssText = 'position: absolute; bottom: 32px; left: 50%; transform: translateX(-39px); width: 48px; height: 48px; display: flex; align-items: center; justify-content: center; background: white; border-radius: 50%; cursor: pointer;';
              },
              onClick: (event, el) => {
                this.lightbox.pswp.close();
              },
            });
            
            this.lightbox.pswp.ui.registerElement({
              name: 'custom-next',
              ariaLabel: 'Next slide',
              order: 9,
              isButton: true,
              html: '<svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none"><circle cx="20" cy="20" r="20" fill="white"/><path d="M11.666 20L28.3327 20" stroke="black" stroke-miterlimit="10"/><path d="M20 14.1666C20.1261 14.7465 20.6808 16.8243 23.33 18.4159C25.2953 19.5967 27.4059 19.9047 28.3333 20" stroke="black" stroke-miterlimit="10"/><path d="M20 25.8333C20.1261 25.2534 20.6808 23.1756 23.33 21.5839C25.2953 20.4032 27.406 20.0951 28.3333 19.9999" stroke="black" stroke-miterlimit="10"/></svg>',
              onInit: (el, pswp) => {
                el.style.cssText = 'position: absolute; bottom: 32px; left: 50%; transform: translateX(33px); width: 48px; height: 48px; display: flex; align-items: center; justify-content: center; background: white; border-radius: 50%; cursor: pointer;';
              },
              onClick: (event, el) => {
                this.lightbox.pswp.next();
              },
            });
          } else {
            this.lightbox.pswp.ui.registerElement({
              name: 'custom-close-single',
              ariaLabel: 'Close',
              order: 8,
              isButton: true,
              html: '<svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_4958_14909)"><path fill-rule="evenodd" clip-rule="evenodd" d="M15.9964 0.00585938L0.00976562 15.9925L15.9964 0.00585938Z" fill="currentColor"></path><path d="M15.9964 0.00585938L0.00976562 15.9925" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M-0.0133448 16L-16 31.9867L-0.0133448 16Z" fill="currentColor"></path><path d="M-0.0133449 16L-16 31.9867" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M16 16.0033L0 0L16 16.0033Z" fill="currentColor"></path><path d="M16 16.0033L0 0" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M31 31.0033L15 15L31 31.0033Z" fill="currentColor"></path><path d="M31 31.0033L15 15" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"></path></g><defs><clipPath id="clip0_4958_14909"><rect width="16" height="16.0033" fill="currentColor"></rect></clipPath></defs></svg>',
              onInit: (el, pswp) => {
                el.style.cssText = 'position: absolute; bottom: 32px; left: 50%; transform: translateX(-24px); width: 48px; height: 48px; display: flex; align-items: center; justify-content: center; background: white; border-radius: 50%; cursor: pointer;';
              },
              onClick: (event, el) => {
                this.lightbox.pswp.close();
              },
            });
          }
        });

        this.lightbox.init();

        FoxTheme.utils.addEventDelegate({
          selector: '.js-photoswipe--zoom',
          context: this,
          handler: (e, media) => {
            if (media.dataset.mediaType === 'image') {
              const index = Number(media.dataset.mediaIndex) || 0;
              this.lightbox.loadAndOpen(index);
            }
          },
        });
      }

      handleSliderAfterInit() {
        this.sliderInstance.slider.on('afterInit', (swiper) => {
          const { slides, activeIndex } = swiper;

          if (slides[activeIndex]) {
            const isModelMediaType = slides[activeIndex].dataset.mediaType === 'model';
            this.toggleSliderDraggableState(!isModelMediaType);
          }
        });
      }

      handleSlideChange() {
        this.sliderInstance.slider.on('realIndexChange', (swiper) => {
          const { slides, activeIndex, thumbs } = swiper;

          if (thumbs.swiper) {
            thumbs.swiper.slideTo(activeIndex);
          }

          if (slides[activeIndex]) {
            this.playActiveMedia(slides[activeIndex]);

            const isModelMediaType = slides[activeIndex].dataset.mediaType === 'model';
            this.toggleSliderDraggableState(!isModelMediaType);
          }
        });
      }

      toggleSliderDraggableState(isDraggable) {
        if (this.sliderInstance.slider.allowTouchMove !== isDraggable) {
          this.sliderInstance.slider.allowTouchMove = isDraggable;
        }
      }

      playActiveMedia(selected) {
        const deferredMedia = selected.querySelector('product-model');
        if (deferredMedia) deferredMedia.loadContent(false);
      }

      setActiveMedia(variant) {
        if (!variant || !variant.hasOwnProperty('featured_media') || !variant.featured_media) return;

        if (this.sliderInstance.slider) {
          const slideIndex = variant.featured_media.position || 0;
          this.sliderInstance.slider.slideToLoop(slideIndex - 1);
        } else {
          this.sortMediaItems(variant);
        }
      }

      sortMediaItems(variant) {
        let newMedias = this.elements.mediaItems;

        // Reset ordering.
        newMedias.sort(function (a, b) {
          return a.dataset.mediaIndex - b.dataset.mediaIndex;
        });

        newMedias.some((media, index) => {
          if (media.dataset.mediaId == variant.featured_media.id) {
            const [element] = newMedias.splice(index, 1);
            newMedias.unshift(element);
            return true;
          }
        });

        this.elements.mediaList.innerHTML = '';
        newMedias.forEach((media) => {
          this.elements.mediaList.appendChild(media);
        });

        if (!FoxTheme.config.mqlMobile) {
          const selectedMedia = this.querySelector(`[data-media-id="${variant.featured_media.id}"]`);
          if (selectedMedia) {
            window.scrollTo({ top: selectedMedia.offsetTop, behavior: 'smooth' });
          }
        }
      }
    }
  );
}